<template>
    <footer class="footer">
        <div class="connect-us">
            <img src="@/assets/img/homes/footer-service-phone.png" alt="footer-service-phone"/>
            <div class="desc">
                <div class="tips">唤醒服务，从现在开始</div>
                <div class="phone">023-63410392</div>
            </div>
        </div>
        <div class="container">
            <div class="container-box">
                <img src="@/assets/img/homes/logo.png" alt="logo"/>
                <div class="divide"/>
                <div class="content">
                    <div class="friend-link">友情链接：</div>
                    <el-row type="flex" justify="space-between">
                        <a href="http://www.cqvip.com/" target="_blank">维普资讯</a>
                        <a href="http://qikan.cqvip.com/" target="_blank">维普中文期刊服务平台</a>
                        <a href="http://zlf.cqvip.com/" target="_blank">智立方知识资源系统</a>
                        <a href="http://k.vipslib.com/account" target="_blank">经纶知识资源系统</a>
                        <a href="http://www.irtree.com/" target="_blank">机构智库</a>
                    </el-row>
                    <div class="company-phone">
                        <span>联系电话：023-63410392 </span>
                        <span>重庆维普朗润数据科技有限公司 渝B2-20050021-1</span>
                    </div>
                    <div class="company-address">
                        <span>联系地址：重庆市两江新区黄山大道信达国际A栋904</span>
                        <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=50019002500403&from=index"
                           target="_blank">
                            渝公网备 500000015-00073 违法和不良信息举报中心
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    name: "Footer"
}
</script>

<style scoped lang="less">
@import "../index";

.footer {
    background-color: #fff;

    .container {
        background-color: #F2F4F7;
        border-radius: 35% 35% 0 0;
        width: 100%;
        padding: 0 @base-padding;
        box-sizing: border-box;

        .container-box {
            box-sizing: border-box;
            display: flex;
            align-items: center;
            padding-top: 150px;
            padding-bottom: 80px;

            .divide {
                margin: 0 70px;
                width: 2px;
                height: 130px;
                background-color: #C6CDDE;
            }
            .content {
                width: 60%;
                .friend-link {
                    font-weight: 600;
                    font-size: 18px;
                    margin-bottom: 20px;
                }
                a {
                    font-size: 16px;
                    cursor: pointer;
                    &:hover {
                        color: #1677ff;
                    }
                }
                .company-phone {
                    display: flex;
                    justify-content: space-between;
                    margin: 50px 0 20px;
                    font-size: 16px;
                }
                .company-address {
                    display: flex;
                    justify-content: space-between;
                    font-size: 16px;
                }
            }

        }

    }

    .connect-us {
        width: 32%;
        margin: 0 auto;
        height: 200px;
        border-radius: 28px;
        background-image: url("~@/assets/img/homes/footer-service-bg.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-position: left top;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        top: 100px;

        .desc {
            margin-left: 40px;
            color: #fff;

            .tips {
                font-size: 16px;
            }

            .phone {
                font-size: 20px;
                margin-top: 10px;
            }
        }
    }
}
</style>
